import React, { useCallback, useEffect, useRef } from 'react';

import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import {
  Root,
  ContainerMyData,
  MyDataTitle,
  MyOrder,
  MyData,
  ContainerActions,
  BackBtn,
  LogoutBtn,
  DeleteAccountBtn,
} from './styles';

import CardPayment from '../../components/CardPayment';
import CardAddress from '../../components/CardAddress';
import { signOut } from '../../store/modules/auth/actions';
import { routesEndpoints } from '../../routes/endpoint';
import { setIsCategory } from '../../store/modules/parameter/actions';

import Input from '../../components/Input';
import { StoreState } from '../../store/createStore';

const Account: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIsCategory(false));
  }, [dispatch]);

  const handledLogout = useCallback(() => {
    dispatch(signOut());
    history.location.state = { isPrivate: false };
  }, [dispatch, history]);

  const handleSubmit = useCallback(async () => {
    //konsole.log('clicou...', formRef.current?.getData());
  }, []);

  const { user } = useSelector((state: StoreState) => state.auth);

  return (
    <Root>
      <ContainerMyData>
        <MyDataTitle>
          <span>Minha Conta</span>
        </MyDataTitle>
        <MyData>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Input
              name="name"
              placeholder="Nome do Endereço*"
              value={user.data.first_name}
            />

          </Form>
        </MyData>
      </ContainerMyData>

      <MyOrder onClick={() => history.push(routesEndpoints.ORDERS)}>
        <span>Meus Pedidos</span>
      </MyOrder>

      <CardPayment title="Meus Pagamentos" />
      <CardAddress title="Meus Endereços" />

      <ContainerActions>
        <BackBtn
          onClick={() => history.push(routesEndpoints.HOME)}
          style={{ cursor: 'pointer' }}
        >
          <span>VOLTAR</span>
        </BackBtn>
        <LogoutBtn onClick={handledLogout}>
          <span>FAZER LOGOUT</span>
        </LogoutBtn>
      </ContainerActions>

      <ContainerActions>
        <DeleteAccountBtn>
          <span>EXCLUIR CONTA</span>
        </DeleteAccountBtn>
      </ContainerActions>
    </Root>
  );
};

export default Account;
